import { connect } from 'react-redux';
import {
    getProductData,
    getProductStock,
} from 'Favourites/store/actions';

import {
    selectSelectedStoreId,
} from 'store/reducers/data/stores';

import {
    selectProduct,
    selectIsProductLoading,
} from 'Favourites/store/reducers/data/products';

import {
    selectSelectedListId,
    selectShoppingListView,
} from 'store/reducers/data/shoppingList';

import {
    selectExcludeVAT,
} from 'store/reducers/data/user';

import { LIST_TYPE } from 'Favourites/store/constants';

const mapStateToProps = (state, ownProps) => {
    const data = selectProduct(state, ownProps.productId);
    const selectedList = selectSelectedListId(state);
    const isLoading = selectIsProductLoading(state, ownProps.productId);
    const store = selectSelectedStoreId(state);
    const listView = selectShoppingListView(state);
    const excludeVAT = selectExcludeVAT(state);

    return { data, selectedList, isLoading, store, listView, excludeVAT };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProductData: (id, type, quantity) => {
            dispatch(getProductData(id, type, quantity, LIST_TYPE));
        },
        getStock: (productData, storeId) => {
            dispatch(getProductStock(productData, storeId, LIST_TYPE));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
